// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------

import axios from 'axios'
import { Toast } from 'vant'
import { getLoc, getCookies, removeCookies } from './utils' // 确保导出包含所需函数
import router from '@/router';

const Setting = {
    apiBaseURL: process.env.VUE_APP_BASE_API || 'http://kefu.weiquanai.com/api/admin'
}

const service = axios.create({
    baseURL: Setting.apiBaseURL,
    timeout: 100000 // 请求超时时间
})

axios.defaults.withCredentials = true // 携带cookie

// 请求拦截器
service.interceptors.request.use(
    config => {
        let baseUrl;
        const region = config.region; // 获取传入的 region
        
        if(region) {
            baseUrl = Setting.apiBaseURL.replace(/admin/, region);
            config.baseURL = baseUrl;
        } else if(config.kefu) {
            baseUrl = Setting.apiBaseURL.replace(/admin/, "kefu")
            config.baseURL = baseUrl
        } else if(config.mobile) {
            baseUrl = Setting.apiBaseURL.replace(/admin/, "mobile");
            config.baseURL = baseUrl
        } else {
            config.baseURL = Setting.apiBaseURL
        }

        const mobileToken = getLoc('mobile_token');

        if(mobileToken) {
            config.headers['Authorization'] = 'Bearer ' + mobileToken;
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        const status = res ? res.status : 0;
        
        switch(status) {
            case 200:
                return res;
            
            // --- 修改部分开始：将原本触发退出的状态码统一拦截并只返回错误信息 ---
            case 400: 
            case 400011: 
            case 400012:
            case 410000:
            case 410001:
            case 410002:
            case 410003:
                // 不再执行 localStorage.clear()
                // 不再执行 router.replace()
                // 只将后端返回的错误信息抛出，让调用接口的地方通过 .catch 处理
                //return Promise.reject(res || { msg: '请求失败' });
                console.log('接口返回错误状态码:', status, '错误信息:', res.msg);
            // --- 修改部分结束 ---

            default:
                // 其他未定义状态码也通过业务逻辑处理
                return res;
        }
    },
    error => {
        // 网络层面的错误（如 500, 404, 跨域等）
        console.log(error.msg || '网络请求异常')
        return Promise.reject(error)
    }
)

export default service